import { IVideo } from "@faire/web-api/indigofair/data/IVideo";
import { isTupleOfLength } from "@faire/web/common/typescriptUtils";

export const getFirstVideo = (videos: IVideo[]): IVideo | undefined => {
  return isTupleOfLength(videos, 1) ? videos[0] : undefined;
};
